module.exports = __webpack_public_path__ + "img/Projects.434d4377.png";